import { useAuth } from '../context/AuthContext';

export const useHandleLogout = () => {
    const { logout } = useAuth();

    const handleLogout = () => {
        logout();
    };

    return { handleLogout };
};
